import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=5bfc3e2d&scoped=true"
var script = {}
import style0 from "./Faq.vue?vue&type=style&index=0&id=5bfc3e2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc3e2d",
  null
  
)

export default component.exports